import api from "./Api";

class OrdemServicoEnderecoService {
  GetOrdemServicoEndereco(payload) {
    return api.get("/v1/ordemServicoEndereco/" + payload).then((response) => {
      return response.data;
    });
  }

  PostOrdemServicoEndereco(payload) {
    return api.post("/v1/ordemServicoEndereco/", payload).then((response) => {
      return response.data;
    });
  }

  PutOrdemServicoEndereco(payload) {
    return api.put("/v1/ordemServicoEndereco/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteOrdemServicoEndereco(payload) {
    return api
      .delete("/v1/ordemServicoEndereco/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  GetOrdemServicoEnderecoOData(payload) {
    return api.get("/OData/OrdemServicoEndereco" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new OrdemServicoEnderecoService();
